import { render } from "./ClickToEditComponent.vue?vue&type=template&id=1bed72f9"
import script from "./ClickToEditComponent.vue?vue&type=script&lang=js"
export * from "./ClickToEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__